import { render, staticRenderFns } from "./ShrineImage.vue?vue&type=template&id=60792af9&"
import script from "./ShrineImage.vue?vue&type=script&lang=js&"
export * from "./ShrineImage.vue?vue&type=script&lang=js&"
import style0 from "./ShrineImage.vue?vue&type=style&index=0&id=60792af9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports